module.exports = __webpack_public_path__ + "img/xldz_theld2coinio.1a1a8be.png";